// src/index.js — entry point
import React from "react";
import ReactDOM from "react-dom/client"; // Importar o createRoot de react-dom/client
import App from "./App";
import { initDraggableModals } from "./Utils/draggableModal";

initDraggableModals();

// Obtém o elemento root da DOM
const rootElement = document.getElementById("root");

// Cria a root e renderiza a aplicação usando createRoot
const root = ReactDOM.createRoot(rootElement);

// Renderiza o App dentro de <React.StrictMode>
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
